import React, { useState } from 'react';
import { getUiLocale, setUiLocale, uiText } from '../../i18n/uiText';
import { useConfirm } from '../../store/ConfirmContext';

export default function InterfaceLanguage({ compact = false }) {
  const confirm = useConfirm(), [error, setError] = useState('');
  const change = async e => {
    const next = e.target.value;
    if (next === getUiLocale()) return;
    const accepted = await confirm(uiText('Смена языка перезагрузит страницу. Сначала сохраните заполненные формы. Продолжить?'), { title: uiText('Язык интерфейса'), confirmLabel: uiText('Сменить язык'), danger: false });
    if (!accepted) return;
    try { setUiLocale(next); window.location.reload(); }
    catch { setError(uiText('Не удалось сохранить выбор языка. Проверьте разрешение на хранение данных сайта.')); }
  };
  return <div className={compact ? 'workspace-language-setting' : 'card-body qualification-stack'}>
    <label className="form-label" htmlFor={compact ? 'menu-interface-language' : 'settings-interface-language'}>{uiText('Язык интерфейса')} / Dil</label>
    <select id={compact ? 'menu-interface-language' : 'settings-interface-language'} className="form-control" value={getUiLocale()} onChange={change}><option value="ru">{uiText("Русский")}</option><option value="az">Azərbaycan dili</option></select>
    {!compact && <p className="form-hint">{uiText('Выбор сохраняется в этом браузере. Содержание аудитов, исходные документы и ответы не переводятся и не изменяются автоматически.')}</p>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
